import { useContext } from 'react';
import ConfigContext from './config-context.js';

var useConfig = (function () {
  return useContext(ConfigContext);
});

export { useConfig as default };
//# sourceMappingURL=use-config.js.map
